import { Component, OnInit, ViewChild, Renderer2 } from "@angular/core";
import { GlobalService } from "src/app/services/global.service";
import Swal from "sweetalert2";
import { NgxSpinnerService } from "ngx-spinner";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import * as moment from "moment";
import { DatePipe } from "@angular/common";
import CryptoJS from "crypto-js";
import * as SecureLS from "secure-ls";
import { ExcelServicesService } from "../../services/excel.service";
import {
  FormBuilder,
  FormGroup,
  FormArray,
  FormControl,
  Validators,
  ValidatorFn,
  ValidationErrors
} from "@angular/forms";
import { CommonService } from "src/app/services/common.service";
import { ErrorModalComponent } from "../error-modal/error-modal.component";
import { StorageService } from "../../services/storage.service";
import { roleIdSix } from "src/app/shared/constants/role.id.constants";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";


const dateRangeValidator: ValidatorFn = (
  control: FormGroup
): ValidationErrors | null => {
  const startDate = control.get("start_date")?.value;
  const endDate = control.get("end_date")?.value;

  if (!startDate || !endDate) {
    return { required: true };
  }

  const start = new Date(startDate);
  const end = new Date(endDate);

  if (end < start) {
    return { invalidRange: true };
  }

  return null;
};

@Component({
  selector: "app-video-details",
  templateUrl: "./video-details.component.html",
  styleUrls: ["./video-details.component.css"],
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
})
export class VideoDetailsComponent implements OnInit {
  private ls = new SecureLS({ encodingType: "aes" });
  expandedElement = false;
  isSixRoleId = false;
  collection = [];
  userID = this.ls.get("createdBy");
  total_count = 0;
  cam: any[];
  htmlpageshow: boolean;
  entryFields: boolean = false;
  createNew: boolean = true;
  editbut = false;
  page_count = [];
  editid: any;
  video: any;
  vid: any;
  is_active: any;
  pageshow = true;
  admstatusupdate: any;
  getVideo: any;
  editschedule: any;
  videoList: any[];
  listVideo: any;
  department_id: any;
  subject_id: any;
  classroom_id: any;
  professorid: any;
  filter_from: any;
  filter_end: any;
  d: Date | string;
  d1: Date | string;
  datecheck: any;
  datecheckstatus = false;
  page: number = 1;
  deleteListPage: number = 1;
  page_size: number = 10;
  prolength: any;
  department_details: any;
  subject_details: any;
  form: FormGroup;
  b: any;
  data: Array<Object> = [
    { id: 0, name: "Active" },
    { id: 1, name: "In Active" },
  ];

  form1 = {
    vedioname: "hit",
    video: null,
  };
  video_message: string;
  filter: any;
  department: any;
  dept: any;
  classroom: any;
  class: any;
  batch: any;
  batch_id: any;
  batchData: any;
  subject: any;
  subjectData: any;
  select_all: any;
  videobulk = [];
  statusform: string;
  total: number;
  p: number;
  pagedItems: any[];
  professor_id: any;
  professorname: Object;
  professorData: any;
  searchForm: FormGroup;
  excelVideoList: any;
  uivideoList: any;
  error_status_id: any;
  errstatus: any;
  viderror: any;
  error_message: any;
  pageno: any;
  recrange: any;
  dropbox: Array<Object> = [];
  check: number;
  chiparray = [];
  filtervalues: boolean;
  isAudiable: string = "";
  audio_availability: any = "";
  isNonNumeric: boolean = true;
  numericError: boolean = false;
  isActive: any = "";
  assignSubmitted: boolean = false;
  assignForm: FormGroup;
  currentRowId: number;
  scheduleDeletedRequestList: any = [];
  role: any;
  write_access: boolean = false;
  hod: any;
  sessionData: any;
  minDate: Date;
  maxDate: Date;
  date1: Date;
  date2: Date;
  startTime: any;
  endTime: any;
  // maxCreateEditDate: Date;
  findedVal: any;
  submitted: boolean = false;
  deleteListTotal_count: any;
  editstatus: Number = 0;
  video_details: any;
  endDate: string;
  startDate: string;
  start_date: string;
  start_time: string;
  end_date: string;
  end_time: string;
  backendValidationErrors: null;
  isDisabled: boolean;
  updateschedule: Object;
  ScheduleForm: FormGroup;
  edit_enable: boolean = false;
  schedule_update: Object;
  inact_schedule: Date | null = null; // The selected date 
  inact_end_schedule: Date | null = null;
  assignSubjectData: any;
  selectedSessionId: any;
  constructor(
    private storageService: StorageService,
    private datepipe: DatePipe,
    public globalService: GlobalService,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private ExcelServicesService: ExcelServicesService,
    public commonService: CommonService,
    private renderer: Renderer2
  ) {
    for (let i = 1; i <= 200; i++) {
      this.collection.push(`item ${i}`);
    }
    this.role = this.storageService.getRole();
    if (this.role === roleIdSix) {
      this.isSixRoleId = true;
    }
  }

  onSubmit(actionType) {
    let selectedList = this.videoList.filter((list) => list.is_selected);
    if (actionType == "2") {
      if (selectedList.every((list) => list.VideoStatus?.status_code == "S6")) {
        this.videobulk = selectedList.map((e) => e.id);
      } else {
        this.videobulk = [];
        Swal.fire(
          "Alert!",
          "Kindly select only 'Video Compression Completed' status in the schedule list",
          "error"
        );
      }
    } else if (actionType == "1") {
      if (selectedList.every((list) => list.is_active != 1)) {
        this.videobulk = selectedList.map((e) => e.id);
      } else {
        this.videobulk = [];
        Swal.fire(
          "Alert!",
          "Kindly select only 'In Active' status from the schedule list",
          "error"
        );
      }
    } else {
      if (selectedList.every((list) => list.is_active == 1)) {
        this.videobulk = selectedList.map((e) => e.id);
      } else {
        this.videobulk = [];
        Swal.fire(
          "Alert!",
          "Kindly select only 'Active' status from the schedule list",
          "error"
        );
      }
    }
    if (this.videobulk?.length) {
      if (actionType == "2") {
        this.bulkVideoListDeleteRequest(this.videobulk, actionType);
      } else {
        this.bulkVideoListStatusUpdate(this.videobulk, actionType);
      }
    }
  }
  onStartDateChange(date: Date) {
    if (this.inact_end_schedule && date && moment(this.inact_end_schedule).isBefore(moment(date), 'day')) {
      this.inact_end_schedule = null;
    }
  }

  async onInactivate(actionType) {
    if (!this.inact_schedule || !this.inact_end_schedule) {
      Swal.fire("Alert!", "Please select start and end date", "error");
      return false;
    }

    if (moment(this.inact_end_schedule).isBefore(moment(this.inact_schedule), "day")) {
      Swal.fire("Alert!", "End date should be greater than or equal to start date", "error");
      return false;
    }

    let filter_date = moment(this.inact_schedule).format("YYYY-MM-DD");
    let filter_end_date = moment(this.inact_end_schedule).format("YYYY-MM-DD");
    const inputData = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      start_date: filter_date,
      end_date: filter_end_date,
      is_active: actionType
    };
    this.schedule_update = await this.globalService.update(
      "classVideoDetail/update-inactive-status",
      inputData
    );

    if (this.schedule_update["status"] === 200) {
      Swal.fire("Success!", this.schedule_update["message"], "success");
      this.inact_schedule = null;
      this.inact_end_schedule = null;
      this.getVideoDetails();
    }
    if (this.schedule_update["status"] != 200) {
      this.inact_schedule = null;
      this.inact_end_schedule = null;
      this.getVideoDetails();
    }

  }

  onSelectAll(e: any) {
    let a = [];
    let b = [];
    for (let i = 0; i < this.videoList.length; i++) {
      a[i] = this.videoList[i];
      a[i].is_selected = e;
    }
    for (let j = 0; j < a.length; j++) {
      b[j] = a[j].id;
    }
  }
  async ngOnInit() {
    this.statusFilter(1);
    this.maxDate = new Date();
    this.minDate = new Date();
    this.minDate = new Date();
    this.date1 = new Date();
    this.date2 = new Date();
    this.date1.setDate(this.date1.getDate());
    this.hod = this.storageService.getHod();
    this.searchForm = this.fb.group({
      id: [""],
      date: [null],
      status_message: [null],
      error_message: [null],
      proname: [null],
      depname: [null],
      batchname: [null],
      class_name: [null],
      sub_name: [null],
      isAudiable: [null],
      audio_availability: [null],
      session: [null],
    });
    this.ScheduleForm = this.fb.group(
      {
        id: [""],
        subject_id: ["", [Validators.required]],
        professor_id: ["", [Validators.required]],
        start_date: ["", [Validators.required]],
        end_date: ["", [Validators.required]],
        start_time: ["", [Validators.required]],
        end_time: ["", [Validators.required]]
      },
      { validator: dateRangeValidator }),
      this.assignForm = this.fb.group({
        session: [{ value: null, disabled: true }, Validators.required],
        sub_name: ["", [Validators.required]],
        profname: ["", [Validators.required]],
      });
    if (this.storageService.getRole() == 4 && this.hod == 1) {
      this.write_access = true;
      this.department_id = this.storageService.getDepartment();
      this.searchForm.controls["depname"].setValue(
        this.department_id
      );
      this.searchForm.controls["depname"].disable();
    }
    await this.getVideostatus();
    await this.getErrorstatus();
    if (this.role === roleIdSix) {
      this.searchForm.controls["audio_availability"].patchValue(50);
    } else {
      this.searchForm.controls["audio_availability"].patchValue("");
    }
    this.chiparray = [];
    this.filtervalues = true;
    await this.getPage(this.page, true);
    await this.getDepartment();
    await this.getBatch();
    await this.getSession();
    await this.getclassroom();
    await this.getSubject();
    await this.getProfessor();
    await this.getSession();

  }
  get forms1() {
    return this.searchForm.controls;
  }
  get form2() {
    return this.assignForm.controls;
  }

  async dropboxdown() {
    this.dropbox = [];
    var count = 1000,
      tempcount = 1000,
      c1,
      c2;
    this.check = Math.ceil(this.total_count / count);
    var cvar = 1;
    for (let i = 1; i <= this.check; i++) {
      c1 = cvar;
      c2 = count;
      cvar = cvar + tempcount;
      count += tempcount;
      this.dropbox.push({ value: i, records: c1 + "-" + c2 });
    }
  }

  getvalue(event: any, rec: any) {
    this.spinner.show();
    this.recrange = rec;
    this.pageno = event;
    this.exportAsXLSX();
  }
  get forms() {
    return this.ScheduleForm.controls;
  }

  async getVideostatus() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.video = await this.globalService.get(
      "classVideoDetail/list/dropdown/schedule/flow/status",
      filter
    );
    this.cam = this.video["content"];
    this.spinner.hide();
  }
  expandRow(eList) {
    this.videoList.forEach((list) => {
      if (eList.id === list.id) {
        list["isExpand"] = true;
      } else {
        list["isExpand"] = false;
      }
    });
  }
  collapseRow(eList) {
    this.videoList.forEach((list) => {
      list["isExpand"] = false;
    });
  }
  async getErrorstatus() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.viderror = await this.globalService.get(
      "classVideoDetail/list/dropdown/error-schedule-status",
      filter
    );

    this.errstatus = this.viderror["content"];
    this.spinner.hide();
  }

  async getDepartment() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.department = await this.globalService.get(
      "department/list/dropdown",
      filter,
      true
    );
    this.dept = this.department["content"];
    this.spinner.show();
  }
  stdate(e) {
    this.startDate = moment(e).format("YYYY-MM-DD");
  }
  endate(e) {
    this.endDate = moment(e).format("YYYY-MM-DD");
  }
  sttime(e) {
    this.startTime = e;
    if (this.endTime != "" && this.endTime != undefined) {
      if (this.endTime < e) {
        this.ScheduleForm.controls["start_time"].setValue(null);
        Swal.fire("Alert!", "End time must be greater start time", "error");
        return;
      }
    }
  }
  entime(e: any) {
    let endTimeArr = e.split(":");
    if (this.startTime) {
      let startTimeArr = this.startTime?.split(":");
      if (startTimeArr[0] == endTimeArr[0]) {
        if (startTimeArr[1] >= endTimeArr[1]) {
          this.ScheduleForm.controls["end_time"].setValue(null);
          Swal.fire("Alert!", "End time must be greater start time", "error");
          return;
        }
      } else if (startTimeArr[0] >= endTimeArr[0]) {
        this.ScheduleForm.controls["end_time"].setValue(null);
        Swal.fire("Alert!", "End time must be greater start time", "error");
        return;
      }
    }
    this.endTime = e;
  }

  getFilterDate(filter_date) {
    this.spinner.show();
    if (filter_date) {
      this.filter = filter_date;
      this.filter_from = moment(this.filter[0]).format("YYYY-MM-DD");
      this.filter_end = moment(this.filter[1]).format("YYYY-MM-DD");
      var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
      var diffDays =
        Math.floor(
          new Date(this.filter_from).getTime() -
          new Date(this.filter_end).getTime()
        ) / oneDay; // hours*minutes*seconds*milliseconds
      if (-diffDays > 180) {
        Swal.fire({
          text: "Please select dates within 180 days",

          icon: "warning",

          confirmButtonText: "OK",

          confirmButtonColor: "#808080",
        });
        this.searchForm.controls["date"].setValue("");
      }
    } else {
      this.filter_from = "";
      this.filter_end = "";
    }
    this.spinner.hide();
  }
  async videoenc(id, hlsStatus) {
    const encrypt = (text) => {
      return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(text));
    };
    const enryptText = hlsStatus == "0" ? "ZERO" : "ONE";
    window.open(
      `/video/play?key=${id}&isHls=${encrypt(
        enryptText
      )}&loginType=${this.storageService.getImpersonateTextForUrl()}`,
      "_blank"
    );
  }
  async getclassroom() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.classroom = await this.globalService.get(
      "classroom/list/dropdown",
      filter,
      true
    );

    this.class = this.classroom["content"];
    this.spinner.hide();
  }
  async getBatch() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.batch = await this.globalService.get(
      "batch/list/dropdown",
      filter,
      true
    );

    this.batchData = this.batch["content"];
    this.spinner.hide();
  }
  async getSession(isFromXlMethod?, isFilter?) {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    let session = await this.globalService.get(
      "session/dropdown",
      filter,
      true
    );
    //this.searchForm.reset();
    this.sessionData = session["content"];
    if (!this.forms1["session"].value) {
      this.forms1["session"].setValue(
        this.storageService.getCurrentSession(this.sessionData)?.session
      );
    }
    this.findedVal = this.sessionData.find(
      (list) => list.session === this.searchForm.controls["session"]?.value
    );
    if (!isFromXlMethod) {
      this.onSessionChangeEvent(true);
    }
    if (!isFilter) {
      this.Filter();
    } else {
      this.spinner.hide();
    }
  }
  async deleteCompletedVideo(list) {
    Swal.fire({
      title: "Delete ?",
      text: "Are you sure you want to delete this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        this.spinner.show();
        let filter = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          role_id: this.storageService.getRole(),
          schedule_data: [list.id],
        };
        let deletedSchedule = await this.globalService.update(
          "classVideoDetail/schedule/delete-request/create",
          filter
        );
        if (deletedSchedule["status"] === 200) {
          this.spinner.hide();
          Swal.fire("Success!", deletedSchedule["message"], "success");
        }
      }
    });
  }

  async onSessionChangeEvent(isInitLoad?) {
    if (!isInitLoad) {
      this.forms1["date"].setValue(null);
      this.getFilterDate(null);
    }
    let sessionVal = this.forms1["session"].value;
    if (sessionVal) {
      this.findedVal = this.sessionData.find(
        (list) => list.session === sessionVal
      );
      await this.getSubjectDropdown();
      this.minDate.setDate(new Date(this.findedVal.start_date).getDate());
      this.minDate.setMonth(new Date(this.findedVal.start_date).getMonth());
      this.minDate.setFullYear(
        new Date(this.findedVal.start_date).getFullYear()
      );
      this.maxDate.setDate(new Date(this.findedVal.end_date).getDate());
      this.maxDate.setMonth(new Date(this.findedVal.end_date).getMonth());
      this.maxDate.setFullYear(new Date(this.findedVal.end_date).getFullYear());
      if (isInitLoad) {
        if (this.storageService.getRole() == 4 && this.hod == 1) {
          this.write_access = true;
          this.department_id = this.storageService.getDepartment();
          this.searchForm.controls["depname"].setValue(
            this.department_id
          );
          this.searchForm.controls["depname"].disable();
        }
        if (this.storageService.getRole() === 4 && this.hod !== 1) {
          this.searchForm.controls["proname"].setValue(
            this.storageService.getProfessor()
          );
          this.professor_id = this.storageService.getProfessor();
          this.searchForm.controls["proname"].disable();
        }
        if (!this.forms1["date"]) {
          this.forms1["date"].setValue([new Date(), new Date()]);
          this.getFilterDate([new Date(), new Date()]);
        }
      }
    } else {
      this.forms1["date"].setValue(null);
      this.getFilterDate(null);
    }
  }

  async onDepartmentChange() {
    await this.getSubjectDropdown();
    await this.getProfessorDropdown();

  }

  async getProfessorDropdown() {
    this.spinner.show();

    const filter: any = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };

    const departmentId = this.searchForm.get("depname")?.value;

    if (departmentId) {
      filter.department_id = departmentId;
    }

    const professor = await this.globalService.get(
      "user/profeser/dropdown",
      filter,
      true
    );

    this.professorData = professor["content"] || [];

    // Clear selected professor after department changes
    this.searchForm.patchValue({
      proname: null,
    });
    this.professor_id = null;

    this.spinner.hide();
  }

  async getSubjectDropdown() {
    const filter: any = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };

    if (this.findedVal?.id) {
      filter.session_id = this.findedVal.id;
    }

    const departmentId = this.searchForm.get("depname")?.value;
    if (departmentId) {
      filter.department_id = departmentId;
    }

    const subject = await this.globalService.get(
      "subject/list/dropdown",
      filter,
      true
    );

    this.subjectData = subject["content"] || [];

    // Clear previously selected subject if needed
    this.searchForm.patchValue({
      sub_name: null,
    });
  }

  async getSubject() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.subject = await this.globalService.get(
      "subject/list/dropdown",
      filter,
      true
    );

    this.subjectData = this.subject["content"];
    this.spinner.hide();
  }

  getUtcToLocale(dateValue, timeValue, isDateRequested) {
    return this.globalService.getUtcToLocale(
      dateValue,
      timeValue,
      isDateRequested
    );
  }
  async getPage(page: number, disableCall: boolean) {
    this.page = page;
    if (!disableCall) {
      await this.getVideoDetails();
    }
    const res = await this.serverCall(this.videoList, page);
    this.total = this.total_count;
    this.p = page;
    this.pagedItems = res;
  }

  async getDeletePage(page: number) {
    this.deleteListPage = page;
    await this.getRequestListData();
  }

  async serverCall(sample: any[], page: number) {
    const perPage = this.page_size;
    const start = (page - 1) * perPage;
    const end = start + perPage;
    return sample;
  }
  async getProfessor() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.professorname = await this.globalService.get(
      "user/profeser/dropdown",
      filter,
      true
    );

    this.professorData = this.professorname["content"];
    if (this.storageService.getRole() == 4 && this.hod !== 1) {
      this.searchForm.controls["proname"].setValue(
        this.storageService.getProfessor()
      );
      this.professor_id = this.storageService.getProfessor();
      this.searchForm.controls["proname"].disable();
    }
    this.spinner.hide();
  }
  async getVideoDetails() {
    this.spinner.show();
    if (this.page === 1) {
      this.listVideo = [];
    }
    var startUTCDate = moment(this.filter_from, "YYYY-MM-DD");
    var endUTCDate = moment(this.filter_end, "YYYY-MM-DD");

    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
      page: this.page,
      page_size: this.page_size,
      video_status_id: this.video_message,
      error_status_id: this.error_message,
      department_id: this.department_id,
      batch_id: this.batch_id,
      professor_id: this.professor_id,
      subject_id: this.subject_id,
      classroom_id: this.classroom_id,
      has_audio: this.isAudiable,
      audio_availability: !this.isSixRoleId ? this.audio_availability : 50,
      is_active: this.isActive,
      camera_start: this.filter_from ? this.filter_from : moment().format("YYYY-MM-DD"),
      camera_end: this.filter_end ? this.filter_end : moment().format("YYYY-MM-DD"),
      session_id: this.findedVal?.id,
    };

    const dateKeyExists = this.chiparray.some((chip) => chip.startsWith("Date :"));

    if (!dateKeyExists) {
      this.chiparray.push("Date :" + " " + filter.camera_start + " - " + filter.camera_end);
    }
    this.getVideo = await this.globalService.get(
      "classVideoDetail/get-all-video-details",
      filter
    );
    this.videoList = this.getVideo["content"]["rows"];
    this.prolength = this.videoList.length;
    if (this.getVideo["status"] === 200) {
      this.videoList = this.getVideo["content"]["rows"];
      this.videoList = this.videoList.map((list) => {
        list["isExpand"] = false;
        const now = moment();
        var startUTCDate = moment.utc(list.start_date + " " + list.start_time, "YYYY-MM-DD HH:mm:ss").subtract(15, 'minutes');
        var endUTCDate = moment.utc(list.end_date + " " + list.end_time, "YYYY-MM-DD HH:mm:ss").subtract(15, 'minutes');
        if (startUTCDate >= now)
          list["edit_enable"] = true;
        else
          list["edit_enable"] = false;
        return list;
      });
      this.total_count = this.getVideo["content"].count;

      if (this.pageshow === true) {
        this.page_count = [];
        let page_count = Math.ceil(this.total_count / this.page_size);
        if (page_count > 1) {
          this.htmlpageshow = true;
        } else {
          this.htmlpageshow = false;
        }
      }
    }

    (error) => {
      this.listVideo = [];
      this.spinner.hide();
    };
    this.dropboxdown();
    this.spinner.hide();
  }

  getUtcTimeToLocale(dateValue, timeValue, isDateRequested) {
    var UTCDate = moment
      .utc(dateValue + " " + timeValue)
      .toDate()
      .toLocaleTimeString("en-US");
    return UTCDate;
  }

  openField() {
    this.entryFields = true;
    this.createNew = false;
    this.ScheduleForm.reset();
    this.submitted = false;
  }

  openEdit() {
    this.entryFields = true;
    this.editbut = false;
    this.ScheduleForm.reset();
    this.submitted = false;
  }

  cancelFields() {
    this.renderer.removeClass(document.body, "modal-open");
    this.entryFields = false;
    this.ScheduleForm.reset();
  }

  editSchedule(id) {
    Swal.fire({
      title: "Edit ?",
      text: "Are you sure you want to edit this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        this.spinner.show();
        this.editbut = true;
        this.openField();
        let filter = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          video_id: id,
        };
        this.editschedule = await this.globalService.get("classVideoDetail/get/stream/video/details", filter);
        this.video_details = this.editschedule["content"];

        if (this.editschedule["status"] === 200) {
          let today = new Date();
          this.date1.setFullYear(
            today.getFullYear(),
            Number(today.getMonth()),
            today.getDate()
          );
          this.ScheduleForm.controls["id"].setValue(this.video_details.id);
          this.ScheduleForm.controls["professor_id"].setValue(
            this.video_details.professor_id
          );

          this.ScheduleForm.controls["subject_id"].setValue(
            this.video_details.subject_id
          );
          this.ScheduleForm.controls["end_date"].setValue(
            this.video_details.end_date
          );
          this.ScheduleForm.controls["start_date"].setValue(
            this.video_details.start_date
          );
          this.spinner.hide();
          this.d = this.getUtcToLocale(
            this.video_details.start_date,
            this.video_details.start_time,
            false
          );
          this.startTime = moment(this.d).format("HH:mm:ss");

          this.ScheduleForm.controls["start_time"].setValue(
            moment(this.d).format("HH:mm:ss")
          );
          this.d1 = this.getUtcToLocale(
            this.video_details.end_date,
            this.video_details.end_time,
            false
          );
          this.endTime = moment(this.d1).format("HH:mm:ss");

          this.ScheduleForm.controls["end_time"].setValue(
            moment(this.d1).format("HH:mm:ss")
          );

          this.editid = this.video_details.id;
          this.editstatus = this.video_details.is_active;
        }
        this.spinner.hide();
      } else {
        this.cancelFields();
      }
    });
  }

  formUpdateReset() {
    this.ScheduleForm.controls["id"].setValue(this.video_details.id);
    this.ScheduleForm.controls["professor_id"].setValue(
      this.video_details.professor_details.first_name
    );

    this.ScheduleForm.controls["suject_id"].setValue(
      this.video_details.subject_details.name
    );

    this.ScheduleForm.controls["end_date"].setValue(
      this.video_details.end_date
    );
    this.ScheduleForm.controls["start_date"].setValue(
      this.video_details.start_date
    );
    this.d = this.getUtcToLocale(
      this.video_details.start_date,
      this.video_details.start_time,
      false
    );

    this.ScheduleForm.controls["start_time"].setValue(
      moment(this.d).format("HH:mm:ss")
    );
    this.d1 = this.getUtcToLocale(
      this.video_details.end_date,
      this.video_details.end_time,
      false
    );

    this.ScheduleForm.controls["end_time"].setValue(
      moment(this.d1).format("HH:mm:ss")
    );
    // this.searchForm.reset();
    this.ScheduleForm.get("id").setValue(this.video_details.id);
  }
  async exportAsXLSX(): Promise<void> {
    this.spinner.show();
    this.getDepartment();
    this.getSubject();
    this.getclassroom();
    this.getSession(true);
    this.getBatch();
    this.getProfessor();
    var count = 1000;
    var startUTCDate = moment(this.filter_from, "YYYY-MM-DD");
    var endUTCDate = moment(this.filter_end, "YYYY-MM-DD");

    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
      page: this.total_count > 1000 ? this.pageno : 1,
      video_status_id: this.video_message,
      error_status_id: this.error_message,
      department_id: this.department_id,
      batch_id: this.batch_id,
      professor_id: this.professor_id,
      subject_id: this.subject_id,
      classroom_id: this.classroom_id,
      page_size: count,
      session_id: this.findedVal?.id,
      is_active: this.isActive,

      camera_start: isNaN(startUTCDate.toDate().getTime())
        ? null
        : startUTCDate.format("YYYY-MM-DD"),
      camera_end: isNaN(endUTCDate.toDate().getTime())
        ? null
        : endUTCDate.format("YYYY-MM-DD"),
    };
    this.getVideo = await this.globalService.get(
      "classVideoDetail/get-all-video-details",
      filter
    );

    this.excelVideoList = this.getVideo["content"]["rows"];
    var startTM;
    var endTM;
    this.excelVideoList.forEach((e, i) => {
      startTM = this.getUtcTimeToLocale(
        this.excelVideoList[i].start_date,
        this.excelVideoList[i].start_time,
        ""
      );
      this.excelVideoList[i]["start_time"] = startTM;
      endTM = this.getUtcTimeToLocale(
        this.excelVideoList[i].end_date,
        this.excelVideoList[i].end_time,
        ""
      );
      this.excelVideoList[i]["end_time"] = endTM;
    });
    var statusArr = ["inActive", "Active"];
    this.uivideoList = this.excelVideoList.map((item: any) => {
      return {
        SUBJECT_NAME: item.subject_details.name,
        DEPARTMENT_NAME: item.department_details.name,
        BATCH: item.batch_details.batch,
        PROFESSOR_NAME: item.professor_details
          ? item.professor_details.first_name + " " + item.professor_details.last_name
          : "",
        CLASS_ROOM_NAME: item.classroom_details.name,
        STATUS_MESSAGE: item.VideoStatus.status_message,
        ERROR_MESSAGE: item.VideoStatusError
          ? item.VideoStatusError.status_message
          : "",
        STARTDATE: item.start_date,
        END_DATE: item.end_date,
        CAMERA_START: item.camera_start,
        CAMERA_END: item.camera_end,
        START_TIME: item.start_time,
        END_TIME: item.end_time,
        AUDIO_AVAILABILITY: item.audio_availability ? item.audio_availability + "%" : "0%",
        STATUS: statusArr[item.is_active],
      };
    });

    if (this.isActive == 1) {
      this.uivideoList = this.uivideoList.filter(
        (item: any) => item.STATUS == "Active"
      );
    }

    this.ExcelServicesService.exportAsExcelFile(
      this.uivideoList,
      "Schedule_List_Report" + "" + [this.recrange]
    );
    this.recrange = "";
    this.total_count = this.getVideo["content"].count;
    this.spinner.hide();
  }
  bulkVideoListStatusUpdate(id, status) {
    if (!status) {
      Swal.fire("Alert!", "Please select the status to update", "error");
      return false;
    }
    this.spinner.show();
    Swal.fire({
      title: "Delete",
      text: "Are you sure you want to Change Status?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        const inputData = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: id,
          is_active: status,
        };

        this.admstatusupdate = await this.globalService.update(
          "classVideoDetail/update-status-bulk",
          inputData
        );

        if (this.admstatusupdate["status"] === 200) {
          Swal.fire("Success!", this.admstatusupdate["message"], "success");
          this.pageshow = true;
          this.select_all = "";
          this.statusform = "";
          this.inact_schedule = null;
          this.inact_end_schedule = null;
          this.videobulk = [];
          this.getVideoDetails();
        }
        if (this.admstatusupdate["status"] != 200) {
          this.pageshow = true;
          this.select_all = "";
          this.statusform = "";
          this.inact_schedule = null;
          this.inact_end_schedule = null;
          this.videobulk = [];
          this.getVideoDetails();
        }
      } else {
        this.pageshow = true;
        this.select_all = "";
        this.statusform = "";
        this.inact_schedule = null;
        this.inact_end_schedule = null;
        this.videobulk = [];
        this.getVideoDetails();
      }
    });
    this.spinner.hide();
  }

  bulkVideoListDeleteRequest(id, status) {
    this.spinner.show();
    Swal.fire({
      title: "Delete",
      text: "Are you sure you want to Delete?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        const inputData = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          role_id: this.storageService.getRole(),
          schedule_data: id,
          delete_type: status,
        };

        let deletRequestData = await this.globalService.update(
          "classVideoDetail/schedule/delete-request/create",
          inputData
        );
        if (deletRequestData["status"] === 200) {
          Swal.fire("Success!", deletRequestData["message"], "success");
          this.pageshow = true;
          this.select_all = "";
          this.statusform = "";
          this.inact_schedule = null;
          this.inact_end_schedule = null;
          this.videobulk = [];
          this.getVideoDetails();
        }
        if (deletRequestData["status"] != 200) {
          this.pageshow = true;
          this.select_all = "";
          this.statusform = "";
          this.inact_schedule = null;
          this.inact_end_schedule = null;
          this.videobulk = [];
          this.getVideoDetails();
        }
      } else {
        this.pageshow = true;
        this.select_all = "";
        this.statusform = "";
        this.inact_schedule = null;
        this.inact_end_schedule = null;
        this.videobulk = [];
        this.getVideoDetails();
      }
    });
    this.spinner.hide();
  }
  loadMore(index) {
    this.pageshow = true;
    this.page = index;
    this.getVideoDetails();
  }
  previous() {
    this.pageshow = true;
    this.page = this.page - 1;
    this.getVideoDetails();
  }
  next() {
    this.pageshow = true;
    this.page = this.page + 1;
    this.getVideoDetails();
  }
  videoListStatusUpdate(value: boolean, id) {
    Swal.fire({
      title: "Delete",
      text: "Are you sure you want to Change Status?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        this.spinner.show();
        let status;
        if (value == false) {
          status = "0";
        } else if (value == true) {
          status = 1;
        }
        const inputData = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: id ? id : this.editid,
          is_active: status,
        };

        this.admstatusupdate = await this.globalService.update(
          "classVideoDetail/update-status-single",
          inputData
        );
        if (this.admstatusupdate["status"] === 200) {
          Swal.fire("Success!", this.admstatusupdate["message"], "success");
          this.pageshow = true;
          this.getVideoDetails();
          this.spinner.hide();
        }
        if (this.admstatusupdate["status"] != 200) {
          this.pageshow = true;
          this.getVideoDetails();
          this.spinner.hide();
        }
        this.is_active = status;
      } else {
        this.pageshow = true;
        this.spinner.hide();
        this.getVideoDetails();
      }
    });
  }
  openScrollableContent(longContent) {
    //this.findedVal = null;
    if (!this.forms1["date"].value) {
      this.forms1["date"].setValue([new Date(), new Date()]);
      this.getFilterDate([new Date(), new Date()]);
    }
    if (this.ls.get("token")) {
      this.modalService.open(longContent, { scrollable: true });
      this.getDepartment();
      this.getSubject();
      this.getclassroom();
      this.getSession(false, true);
      this.getBatch();
      this.getProfessor();
    }
    this.onSessionChangeEvent(true);
  }
  openActionContent(shortContent) {
    this.modalService.open(shortContent, { scrollable: true });
  }
  openDayAction(shortContent1) {
    this.modalService.open(shortContent1, { scrollable: true, centered: true });
  }
  openErrorModal(errMsg, id) {
    if (errMsg) {
      const errorModalComp = this.modalService.open(ErrorModalComponent, {
        scrollable: true,
      });
      errorModalComp.componentInstance.id = id;
      errorModalComp.componentInstance.errMsg = errMsg
        ? errMsg
        : "--No Error Message--";
    }
  }
  Filter() {
    this.filtervalues = true;
    this.chiparray = [];
    if (this.searchForm.controls["session"]?.value) {
      this.chiparray.push(
        "Session : " + this.searchForm.controls["session"]?.value
      );
    }
    if (this.filter != undefined && this.filter != "") {
      this.chiparray.push(
        "Date :" + " " + this.filter_from + " - " + this.filter_end
      );
    }

    if (this.video_message != undefined && this.video_message != "") {
      var vidmsg = this.cam.filter((x) => x.id == this.video_message);
      this.chiparray.push("Vidmsg:" + " " + vidmsg[0].status_message);
    }
    if (this.error_message != undefined && this.error_message != "") {
      var errmsg = this.errstatus.filter((x) => x.id == this.error_message);
      this.chiparray.push("Errmsg :" + " " + errmsg[0].status_message);
    }
    if (this.professor_id != undefined && this.professor_id != "") {
      var proffessor = this.professorData.filter(
        (x) => x.id == this.professor_id
      );
      if (proffessor.length > 0 && proffessor[0]) {
        this.chiparray.push(
          "Proff:" +
          " " +
          proffessor[0].first_name +
          " " +
          proffessor[0].last_name
        );
      }
    }

    if (this.department_id != undefined && this.department_id != "") {
      var dept = this.dept.filter((x) => x.id == this.department_id);
      this.chiparray.push("Dept:" + " " + dept[0].name);
    }

    if (this.subject_id != undefined && this.subject_id != "") {
      var subject = this.subjectData.filter((x) => x.id == this.subject_id);
      this.chiparray.push("Subject:" + " " + subject[0].name);
    }

    if (this.batch_id != undefined && this.batch_id != "") {
      var batch = this.batchData.filter((x) => x.id == this.batch_id);
      this.chiparray.push("Batch:" + " " + batch[0].batch);
    }

    if (this.classroom_id != undefined && this.classroom_id != "") {
      var classroom = this.class.filter((x) => x.id == this.classroom_id);
      this.chiparray.push("Class:" + " " + classroom[0].name);
    }
    if (this.searchForm.controls["audio_availability"]?.value) {
      this.chiparray.push(
        "Audio Availability : " +
        this.searchForm.controls["audio_availability"]?.value
      );
    }

    if (this.department_id !== "" || this.subject_id !== "" || this.batch_id) {
      this.department_id = this.department_id ? this.department_id : this.searchForm.controls["depname"]?.value;
      this.subject_id = this.searchForm.controls["sub_name"]?.value;
      this.classroom_id = this.searchForm.controls["class_name"]?.value;
      this.video_message = this.searchForm.controls["status_message"]?.value;
      this.error_message = this.searchForm.controls["error_message"]?.value;
      this.batch_id = this.searchForm.controls["batchname"]?.value;
      this.professor_id = this.searchForm.controls["proname"]?.value;
    } else {
      this.department_id = "";
      this.subject_id = "";
      this.classroom_id = "";
      this.video_message = "";
      this.error_message = "";
      this.batch_id = "";
      this.professor_id = "";
    }

    this.pageshow = true;
    this.page = 1;
    this.getVideoDetails();
  }
  res() {
    this.forms1["date"].setValue(null);
    this.getFilterDate(null);
    this.chiparray = [];
    this.chiparray.push(
      "Session : " + this.storageService.getCurrentSession(this.sessionData)?.session
    );
    if (this.storageService.getRole() == 4 && this.hod == 1) {
      var dept = this.dept.filter((x) => x.id == this.department_id);
      this.chiparray.push("Dept:" + " " + dept[0].name);
      this.professor_id = null;
    }
    if (this.storageService.getRole() == 4 && this.hod != 1) {
      var proff = this.professorData.filter((x) => x.id == this.professor_id);
      if (proff.length > 0 && proff[0]) {
        this.chiparray.push("Proff:" + " " + proff[0].first_name + " " + proff[0].last_name);
      }
      this.department_id = null;
    }

    if (this.storageService.getRole() != 4 && this.hod != 1) {
      this.department_id = null;
      this.professor_id = null;
    }

    this.forms1["date"].setValue([new Date(), new Date()]);
    this.getFilterDate([new Date(), new Date()]);
    this.subject_id = null;
    this.classroom_id = null;
    this.filter_from = null;
    this.filter_end = null;
    this.video_message = null;
    this.error_message = null;
    this.batch_id = null;
    this.audio_availability = "";
    this.isAudiable = "";
    // this.professor_id = null;
    this.select_all = null;
    this.start_time = null;
    this.start_date = null;
    this.end_date = null;
    this.end_time = null;
    this.startTime = null;
    this.endTime = null;
    this.date1 = new Date();
    this.date2 = new Date();
    this.statusform = null;
    this.inact_schedule = null;
    this.inact_end_schedule = null;
    this.searchForm.reset();
    this.pageshow = true;
    this.page = 1;
    this.getVideoDetails();
  }

  reset() {
    this.submitted = false;
    this.ScheduleForm.reset();
  }
  onPageCountChange(value) {
    if (value >= 5) {
      this.page_size = value;
    }
    this.getVideoDetails();
  }
  onChange(value) {
    this.isAudiable = value;
  }
  statusFilter(value) {
    if (value) {
      this.isActive = 1;
    } else {
      this.isActive = "";
    }
    this.getVideoDetails();
  }
  checkNumeric(value) {
    this.audio_availability = this.searchForm.controls.audio_availability.value;
    if (this.audio_availability == null) {
      this.audio_availability = "";
    }
    if (value % 1 != 0) {
      this.isNonNumeric = true;
      this.audio_availability = "";
      this.numericError = true;
    } else {
      this.isNonNumeric = false;
      this.numericError = false;
    }
  }
  async onAssign(content, currentRowId, sessionId, sessionName) {
    console.log("sessionData", this.sessionData);
    if (this.ls.get("token")) {
      this.currentRowId = currentRowId;
      this.modalService.open(content, { scrollable: true });
    }
    const session = (this.sessionData || []).find(s => s.id == sessionId || s.session == sessionName);
 
    this.assignForm.patchValue({
      session: session ? session.session : sessionName,
      profname: null,
      sub_name: null
    });

    this.professor_id = null;
    this.subject_id = null;
    this.selectedSessionId = sessionId;

    await this.getSubjectDropdownForAssign();
    this.getProfessor();
    this.getSubject();
    this.assignSubmitted = false;
  }

  async getSubjectDropdownForAssign() {  
    const filter: any = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
      session_id: this.selectedSessionId
    };
   
    const subject = await this.globalService.get(
      "subject/list/dropdown",
      filter,
      true
    );
   
    this.assignSubjectData = subject["content"] || [];
  }

  async onChangeAssign(professorId, subjectId) {
    this.assignSubmitted = true;

    if (this.assignForm.valid) {
      this.submitted = true;
      this.spinner.show();
      let responseData = await this.globalService.update(
        "classVideoDetail/assign/professor",
        {
          vendor_id: this.ls.get("vendor_id"),
          user_id: this.ls.get("createdBy"),
          id: this.currentRowId,
          professor_id: professorId,
          subject_id: subjectId,
        }
      );
      this.modalService.dismissAll();
      this.spinner.hide();
      if (responseData["status"] === 200) {
        this.getVideoDetails();
        this.assignSubmitted = false;
        Swal.fire("Success!", responseData["message"], "success");
      } else if (responseData["status"] === 400) {
        Swal.fire("Error", responseData["error"].message, "error");
      }
    } else {
      Swal.fire("Warning!", "Please fill out the required fields.");
    }
  }

  async openRequestList(deleteRequestList) {
    this.modalService.open(deleteRequestList, {
      scrollable: true,
      size: "xl",
    });
    this.getDeletePage(this.deleteListPage);
  }

  async getRequestListData() {
    this.spinner.show();
    let requestListParams = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
      page: this.deleteListPage,
      page_size: 10,
    };
    let scheduleDeletedRequestList = await this.globalService.get(
      "classVideoDetail/schedule/delete-request/list",
      requestListParams
    );
    if (scheduleDeletedRequestList["status"] === 200) {
      this.scheduleDeletedRequestList =
        scheduleDeletedRequestList["content"]["rows"];
      this.deleteListTotal_count = scheduleDeletedRequestList["content"]?.count;
    }
    this.spinner.hide();
  }

  async updateSchedule(form: FormGroup) {
    this.submitted = true;

    if (this.ScheduleForm.invalid) {
      return;
    } else {
      var startUTCDate = moment(
        (this.startDate ? this.startDate : form.value.start_date) +
        " " +
        (this.startTime ? this.startTime : form.value.start_time),
        "YYYY-MM-DD HH:mm:ss"
      ).utc();
      var endUTCDate = moment(
        (this.endDate ? this.endDate : form.value.end_date) +
        " " +
        (this.endTime ? this.endTime : form.value.end_time),
        "YYYY-MM-DD HH:mm:ss"
      ).utc();

      const inputData = {
        id: form.value.id,
        user_id: this.ls.get("createdBy"),
        vendor_id: this.ls.get("vendor_id"),
        subject_id: form.value.subject_id,
        professor_id: form.value.professor_id,
        start_date: startUTCDate.format("YYYY-MM-DD"),
        end_date: endUTCDate.format("YYYY-MM-DD"),
        start_time: startUTCDate.format("HH:mm:ss"),
        end_time: endUTCDate.format("HH:mm:ss"),
        role_id: this.storageService.getRole(),
      };

      this.spinner.show();
      this.updateschedule = await this.globalService.update(
        "classVideoDetail/schedule/update",
        inputData
      );

      if (this.updateschedule["status"] === 200) {
        Swal.fire("Success!", this.updateschedule["message"], "success");
        this.spinner.show();
        this.pageshow = true;
        this.getVideoDetails();
        this.chiparray = [];
        let currentsession = this.storageService.getCurrentSession(this.sessionData)?.session;
        if (currentsession !== undefined) {
          this.chiparray.push(
            "Session : " + currentsession
          );
        }
        this.editbut = false;
        this.reset();
        this.entryFields = false;
        this.createNew = true;
      }
      this.cancelFields();
      this.spinner.hide();
    }
  }

}
